import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpParams, HttpEventType, HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';

//import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

//import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//import { UserService } from '../../services/user.service';
//import { RegistrationDataService } from '../../services/registration.data.service';

//import { RegistrationValidationComponent } from '../../modals/sign_up_validation.modal/sign_up_validation.modal.component';

import { UserPostsDataService } from '../../services/posts.service';
import { SessionService } from '../../services/session.service';

import *  as Classes from '../../classes/models.classes'

@Component({
    selector: 'app-reply-submit-modal',
    templateUrl: './reply-submit-modal.component.html',
    styleUrls: ['./reply-submit-modal.component.css']
})
export class ReplySubmitModalComponent {
    @Input() OriginalPostID: number;
    @Input() ReplyPostID: number;
    @Input() PostUsername: string;

    @Output() postEditedOrDeleted = new EventEmitter<string>(); // Emit the comment

    comment: string = 'refresh';

    UserPostsDataContent: Classes.ShortsPostSave;

    UserID: number;
    Username: string;
    UserImg: string;

    constructor(
        private sessionService: SessionService,
        private userPostsDataService: UserPostsDataService,
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit(): void {
        this.sessionService.getUserID().subscribe(userID => {
            this.UserID = Number(userID);
        });

        this.sessionService.getUsername().subscribe(username => {
            this.Username = username;
        });

        this.sessionService.getUserImg().subscribe(userImg => {
            this.UserImg = userImg;
        });


        this.UserPostsDataContent = new Classes.ShortsPostSave();
        // Assign received values
        this.UserPostsDataContent.OriginalPostID = this.OriginalPostID;
        this.UserPostsDataContent.ParentPostID = this.ReplyPostID;
    }

    onPostSaved(): void {
        this.postEditedOrDeleted.emit(this.comment); // Emit the comment to the parent component
        this.activeModal.close(); // Close the modal
    }

    onCancel(): void {
        this.activeModal.dismiss(); // Dismiss the modal without doing anything
    }
}

